import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/armchair"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C2.44772 1 2 1.44772 2 2V4.03544C3.69615 4.27806 5 5.73676 5 7.5V9H11V7.5C11 5.73676 12.3039 4.27806 14 4.03544V2C14 1.44772 13.5523 1 13 1H3ZM13 7.5V9V11H3V9V7.5C3 6.84689 2.5826 6.29127 2 6.08535C1.84361 6.03008 1.67532 6 1.5 6C0.671573 6 0 6.67157 0 7.5V14H2V16H4V14H12V16H14V14H16V7.5C16 6.67157 15.3284 6 14.5 6C14.3247 6 14.1564 6.03008 14 6.08535C13.4174 6.29127 13 6.84689 13 7.5Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Armchair16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Armchair16 = createIcon(IconComponent);